module.exports = __webpack_public_path__ + "img/card4.82c48b55.jpg";